module.exports = __webpack_public_path__ + "static/media/1-12.2a080c12.mp3";